module.exports = __webpack_public_path__ + "static/media/spray-brand.7310d839.png";